import { SERVER_URI, TEST_URI, SERVER_URI1 } from '../Constant/server';
import { apiGet, apiPost, apiPost1,apiPut1,apiPut } from '../utils/axios';

const CREATE_PACKAGE = SERVER_URI + '/create-package';
const GET_PACKAGE = SERVER_URI + '/get-package';
const UPDATE_PACKAGE = SERVER_URI + '/update-package/';
const CREATE_ADDON = SERVER_URI + '/create-addon';
const GET_ADDON = SERVER_URI + '/get-addon';
const UPDATE_ACTIVITY = SERVER_URI + '/update-addon/';
const CHANGE_PACKAGE_STATUS = SERVER_URI + '/change-status-package/';
const CHANGE_ACTIVITY_STATUS = SERVER_URI + '/change-status-addon/';




export default {
    createPackage: async function (payload) {
        return apiPost(CREATE_PACKAGE, payload);
    },
    addActivity: async function (paylaod) {
        return apiPost1(CREATE_ADDON, paylaod);
    },
    get_Addon: async function (paylaod) {
        return apiPost(GET_ADDON, paylaod);
    },

    getPackage: async function (payload) {
        return apiPost(GET_PACKAGE, payload);
    },
    updatePackage: async function (id, payload) {
        return apiPut(UPDATE_PACKAGE + id, payload)
    },
    updateActivity:async function (id,payload){
        return apiPut1(UPDATE_ACTIVITY + id,payload)
    },
    changePackageStatus: async function (id) {
        return apiGet(CHANGE_PACKAGE_STATUS + id);
    
      },
      changeActivityStatus:async function(id){
        return apiGet(CHANGE_ACTIVITY_STATUS + id) 
      }

}

